import { Injectable } from '@angular/core';

export class Message {
  constructor(
    public sender: string,
    public content: string,
    public isBroadcast = false,
  ) { }
}

@Injectable()
export class WebSocketAPI {
  constructor() { }

  _connect() {
    // WebSocket y SockJS deshabilitados temporalmente.
  }

  _disconnect(): void {
    // WebSocket y SockJS deshabilitados temporalmente.
  }

  _send(message: any): void {
    void message;
    // WebSocket y SockJS deshabilitados temporalmente.
  }
}
